import React from 'react';
import type { Organizer } from '@/types';
import { AvatarComponent } from './AvatarComponent/AvatarComponent';

interface OrganizerAvatarProps {
  organizer: Organizer;
  size?: 'small' | 'large';
  variant?: 'default' | 'organizer-info';
}

export const OrganizerAvatar: React.FC<OrganizerAvatarProps> = ({ organizer, size = 'large', variant = 'default' }) => {
  return <AvatarComponent organizer={organizer} size={size} variant={variant} />;
};
